import { createContext, useContext } from 'react';
import type { UploadBatchStore } from '@/lib/upload-batch-store';

export const UploadBatchContext = createContext<UploadBatchStore | null>(null);

export function useUploadBatchStore(): UploadBatchStore {
  const store = useContext(UploadBatchContext);
  if (store === null) throw new Error('Uploads require the application upload provider.');
  return store;
}
